/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Order Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Status of order to be placed. draft: order is stored in system, cpId is issued but no CO2-certificates are reserved, all values (e. g. emissionsInKg) can be changed. fixed: order is stored in system, cpId is issued and CO2-certificates are reserved, certain values (e. g. emissionsInKg) can no longer be changed.
 */

export enum OrderCommitmentEnum {
    Draft = 'draft',
    Fixed = 'fixed',
    Invoiced = 'invoiced'
}



